import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBox from 'UIComponents/layout/UIBox';
import { getProductNameTextFromApiName } from '../../_core/common/adapters/getProductNameText';
import { getUpgradeButtonTextFromApiName } from '../../_core/common/adapters/getUpgradeButtonText';
import UIPricingPageRedirectButton from '../../button/UIPricingPageRedirectButton';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { CRM_SUITE_STARTER_BUNDLE } from 'self-service-api/constants/ApiNames';
import { SUITE_STARTER } from 'self-service-api/constants/UpgradeProducts';
import { getBannerI18nTitleKey } from '../utils';
import DefaultBanner from './DefaultBanner';
import { useUpgradeDataFromUpgradeConfig } from './useUpgradeDataFromUpgradConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RemoveBrandingBanner = ({
  upgradePoint,
  className,
  style,
  gates,
  'data-test-id': dataTestId = 'locked-feature-banner',
  isFreePortal = false
}) => {
  const upgradeData = useUpgradeDataFromUpgradeConfig(upgradePoint);
  const correctedUpgradeData = Object.assign({
    feature: upgradePoint.feature,
    pointType: upgradePoint.pointType,
    upgradeKey: upgradePoint.upgradeKey
  }, upgradeData);
  const apiNameToUse = upgradeData.apiName || UpgradeProductToApiNameMap[correctedUpgradeData.upgradeProduct];
  return /*#__PURE__*/_jsx(DefaultBanner, {
    className: className,
    dataTestId: dataTestId,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: getBannerI18nTitleKey('upgrades.removeBrandingBanner.titles', upgradePoint.featureTranslationKey)
    }),
    subtext: /*#__PURE__*/_jsxs(UIBox, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.lockedFeatureBanner.text"
      }), "\xA0", /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.message.productName",
        options: {
          productName: getProductNameTextFromApiName(apiNameToUse, gates)
        }
      })]
    }),
    button: /*#__PURE__*/_jsx(UIPricingPageRedirectButton, {
      upgradeData: correctedUpgradeData,
      use: "tertiary-light",
      isUpgradePoint: true,
      goToUpgradePage: isFreePortal && (correctedUpgradeData.apiName === CRM_SUITE_STARTER_BUNDLE || correctedUpgradeData.upgradeProduct === SUITE_STARTER),
      children: getUpgradeButtonTextFromApiName('default', apiNameToUse, gates)
    }),
    style: style
  });
};
export default RemoveBrandingBanner;